import React, { useEffect, useState } from "react";
import { Box, SimpleGrid, Flex, useToast } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../firebase";

import Profile     from "./components/Profile";
import Information from "./components/Information";
import Password    from "./components/Password";
import AppPrefs    from "./components/AppPrefs";

export default function Settings() {
  const { id }  = useParams();
  const toast   = useToast();
  const [formData, setFormData]   = useState(null);
  const [saving,   setSaving]     = useState(false);

  // Carrega dados do Firestore
  useEffect(() => {
    if (!id) return;
    getDoc(doc(db, "users", id)).then((snap) => {
      if (snap.exists()) setFormData({ uid: id, ...snap.data() });
    });
  }, [id]);

  const handleChange = (field, value) =>
    setFormData((prev) => ({ ...prev, [field]: value }));

  const handleSave = async () => {
    if (!id || !formData) return;
    setSaving(true);
    try {
      // Salva só campos editáveis — não sobrescreve uid/role/etc.
      const { uid, role, criadoEm, ...editavel } = formData;
      await updateDoc(doc(db, "users", id), editavel);
      toast({ title: "Dados salvos!", status: "success", duration: 3000, position: "top-right", isClosable: true });
    } catch (err) {
      console.error(err);
      toast({ title: "Erro ao salvar", description: "Tente novamente.", status: "error", duration: 4000, position: "top-right", isClosable: true });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box pt={{ base: '8px', md: '16px', xl: '0px' }} pb={{ base: '80px', xl: '20px' }}>
      <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="20px">
        {/* Coluna esquerda */}
        <Flex direction="column" gap="20px">
          <Profile
            formData={formData}
            uid={id}
            onPhotoUpdate={(url) => handleChange("photoURL", url)}
          />
          <Information
            formData={formData}
            onChange={handleChange}
            onSave={handleSave}
            saving={saving}
          />
        </Flex>

        {/* Coluna direita */}
        <Flex direction="column" gap="20px">
          <Password />
          <AppPrefs />
        </Flex>
      </SimpleGrid>
    </Box>
  );
}
